/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const SearchBasicLayout = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'SearchBasicLayout',
    hasSortOption: false,
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [hasSortOption, setHasSortOption] = useState([]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          hasSortOption: currentHasSortOption,
        } = component;

        setState(component);
        setHasSortOption(currentHasSortOption);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      hasSortOption,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    hasSortOption,

  ]);

  return (
    <div className="flex justify-start flex-col text-black">
      <div className="flex justify-end w-full my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">DO YOU NEED A 'Sort Option'?</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={hasSortOption}
            onChange={() => setHasSortOption(!hasSortOption)}
            checked={hasSortOption}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
        </div>
      </div>

    </div>
  );
};

SearchBasicLayout.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
SearchBasicLayout.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default SearchBasicLayout;
